import { render, staticRenderFns } from "./CartSubmitFooter.vue?vue&type=template&id=cbec5e26&scoped=true&"
import script from "./CartSubmitFooter.vue?vue&type=script&lang=js&"
export * from "./CartSubmitFooter.vue?vue&type=script&lang=js&"
import style0 from "./CartSubmitFooter.vue?vue&type=style&index=0&id=cbec5e26&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbec5e26",
  null
  
)

export default component.exports